module.exports = __webpack_public_path__ + "img/card2.6c2dd4f5.png";